import { render, staticRenderFns } from "./HighlightStep1.vue?vue&type=template&id=2fc2f1bb&scoped=true"
import script from "./HighlightStep1.vue?vue&type=script&lang=js"
export * from "./HighlightStep1.vue?vue&type=script&lang=js"
import style0 from "./HighlightStep1.vue?vue&type=style&index=0&id=2fc2f1bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc2f1bb",
  null
  
)

export default component.exports